"use client";

import { AccountMenu, AccountMenuMobile } from "@/components/account/account-nav-item";
import { ShopifyLogin, ShopiyLoginMobile } from "@/components/layout/shopify-login";
import { getLoginStatusFromCookie } from "@/lib/shopify/auth/client-utils/getLoginStatusFromCookie";
import { handleShopifyLogin } from "@/lib/shopify/auth/customer-login";
import { LoaderIcon } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

export const AuthNav = () => {
  const [isClient, setIsClient] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsClient(true);
    setIsLoggedIn(getLoginStatusFromCookie());
  }, []);

  if (!isClient) {
    return (
      <button
        className="nav-link pointer-events-none flex h-16 w-[110px] items-center border-r-1 border-primary px-6 text-primary focus:ring-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        disabled
      >
        <LoaderIcon className="mx-auto h-4 w-4 animate-spin" />
      </button>
    ); // Loading state
  }

  return <>{isLoggedIn ? <AccountMenu /> : <ShopifyLogin />}</>;
};

export const AuthNavMobile = () => {
  const [isClient, setIsClient] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsClient(true);
    setIsLoggedIn(getLoginStatusFromCookie());
  }, []);

  if (!isClient) {
    return (
      <button
        className="nav-link pointer-events-none flex h-16 items-center px-6 text-primary focus:ring-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        disabled
      >
        {/* <LoaderIcon className="mx-auto h-4 w-4 animate-spin" /> */}
      </button>
    ); // Loading state
  }

  return <>{isLoggedIn ? <AccountMenuMobile /> : <ShopiyLoginMobile />}</>;
};

export const AuthNavLinks = ({ style }: { style: string }) => {
  const [isClient, setIsClient] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsClient(true);
    setIsLoggedIn(getLoginStatusFromCookie());
  }, []);

  if (!isClient) {
    return (
      <button
        className="nav-link pointer-events-none flex h-16 w-[110px] items-center border-r-1 border-primary px-6 text-primary focus:ring-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
        disabled
      >
        {/* <LoaderIcon className="mx-auto h-4 w-4 animate-spin" /> */}
      </button>
    ); // Loading state
  }

  return (
    <>
      {isLoggedIn ? (
        <li className={style}>
          <Link href={"/account"} prefetch={true}>
            Account
          </Link>
        </li>
      ) : (
        <li className={style} onClick={handleShopifyLogin}>
          Login
        </li>
      )}
    </>
  );
};
